import React from "react";
import NumberInput from "../FormElements/NumberInput";
import Switch from "../FormElements/Switch";

export default class LearningPlanBuilderExam extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onChangeCourseQuestion = this.onChangeCourseQuestion.bind(this);
    this.onAddCourseQuestions = this.onAddCourseQuestions.bind(this);
    this.onRemoveCourseQuestions = this.onRemoveCourseQuestions.bind(this);
  }

  render() {
    const { item = {} } = this.props;
    const { learnable_id } = item;

    return (
      <div>
        <div className="row">
          <div className="col-sm-4">
            <div className="form-group">
              <label>
                {I18n.t("admin.exam")} {I18n.t("admin.name")}
              </label>
              <input
                type="text"
                name="name"
                value={this.props.name}
                className="form-control"
                onChange={this.onChange}
              />
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t("passing_score")}</label>
              <br />
              <NumberInput
                style={{ maxWidth: "88px" }}
                name="passing_score"
                min={0}
                max={100}
                value={
                  typeof this.props.passing_score !== "undefined"
                    ? this.props.passing_score
                    : 80
                }
                onChange={this.onChange}
              />
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <label>{I18n.t("admin.locked")}</label>
              <Switch
                id={`locked-${learnable_id}`}
                isOn={this.props.locked}
                handleToggle={() => {
                  this.onChange({
                    target: {
                      name: "locked",
                      value: !this.props.locked,
                    },
                  });
                }}
              />
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t("score_released")}</label>
              <select
                name="score_released"
                value={this.props.score_released}
                className="form-control form-control-sm"
                onChange={this.onChange}
              >
                <option value="automatic">{I18n.t("automatic")}</option>
                <option value="manual">{I18n.t("manual")}</option>
              </select>
            </div>
          </div>
        </div>

        <div className="form-group">
          <button
            type="button"
            className="btn btn-sm btn-default"
            onClick={this.onAddCourseQuestions}
          >
            {I18n.t("admin.add_course_questions")}
          </button>
        </div>
        {this.renderCourseQuestions()}
      </div>
    );
  }

  renderCourseQuestions() {
    const { item } = this.props;
    const { course_questions = [] } = item;

    if (course_questions && course_questions.length) {
      return (
        <div className="course-questions-wrapper">
          {course_questions.map((course_question, index) => {
            const course = this.props.courses.find(
              (course) => course.id == course_question.course_id
            );
            return (
              <div className="course-questions" key={index}>
                <div className="form-group">
                  <label>{I18n.t("admin.course")}</label>
                  <br />
                  <select
                    name="course_id"
                    value={course_question.course_id}
                    onChange={this.onChangeCourseQuestion.bind(this, index)}
                    className="form-control"
                  >
                    <option value="">{I18n.t("admin.please_select")}</option>
                    {this.props.courses.map((course) => {
                      return (
                        <option key={course.id} value={course.id}>
                          {course.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="row">
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label>{I18n.t("admin.questions")}</label>
                      <br />
                      <NumberInput
                        style={{ maxWidth: "88px" }}
                        name="number_of_questions"
                        min={0}
                        max={course ? course.number_of_questions : 0}
                        value={course_question.number_of_questions}
                        onChange={this.onChangeCourseQuestion.bind(this, index)}
                      />
                    </div>
                  </div>
                  <div className="col-sm-8">
                    <div className="form-group">
                      <label>{I18n.t("admin.from")}</label>
                      <br />
                      <select
                        className="form-control"
                        name="question_pool"
                        value={course_question.question_pool}
                        onChange={this.onChangeCourseQuestion.bind(this, index)}
                      >
                        {/* <option value="">
                          {I18n.t("admin.please_select")}
                        </option> */}
                        <option value="course">
                          {I18n.t("admin.from_course_question_pool")}
                        </option>
                        {/* <option value="article">
                          {I18n.t("admin.from_each_article")}
                        </option> */}
                      </select>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn btn-sm btn-link btn-remove"
                  onClick={this.onRemoveCourseQuestions.bind(this, index)}
                >
                  {I18n.t("admin.remove")}
                </button>
              </div>
            );
          })}
        </div>
      );
    }
  }

  onChange(event) {
    const new_item = {
      ...this.props.item,
      [event.target.name]: event.target.value,
    };

    this.props.onChangeItem(new_item);
  }

  onChangeCourseQuestion(index, event) {
    const course_questions = [...this.props.item.course_questions];
    course_questions[index][event.target.name] = event.target.value;

    const new_item = {
      ...this.props.item,
      course_questions: [...course_questions],
    };

    this.props.onChangeItem(new_item);
  }

  onAddCourseQuestions() {
    const { item } = this.props;
    const { course_questions = [] } = item;
    const new_course_questions = [
      { course_id: "", number_of_questions: "" },
      ...course_questions,
    ];

    const new_item = {
      ...item,
      ["course_questions"]: new_course_questions,
    };

    this.props.onChangeItem(new_item);
  }

  onRemoveCourseQuestions(index) {
    const { item } = this.props;
    const { course_questions = [] } = item;

    const new_item = {
      ...item,
      ["course_questions"]: course_questions.filter((_item, idx) => {
        return index !== idx;
      }),
    };

    this.props.onChangeItem(new_item);
  }
}
